import awesomeGreen from './awesome-green.png';
import blackOrange from './black-orange.png';
import blueHue from './blue-hue.png';
import blueOrange from './blue-orange.png';
import blueRed from './blue-red.png';
import grayScale from './grayscale.png';
import heatMap from './heat-map.png';
import jet from './jet.png';
import pastelShades from './pastel-shades.png';
import {ColorMapKey} from "../../../redux/settings-slice";
import {t} from '../../../localization';

class ColorMap {
  public id: ColorMapKey;
  public image: string;

  constructor(id, image) {
    this.id = id;
    this.image = image;
  }

  get name() {
    return t(`color-map.${this.id}`);
  }
}

export const colorMaps: ColorMap[] = [
  new ColorMap("heat-map", heatMap),
  new ColorMap("awesome-green", awesomeGreen),
  new ColorMap("pastel-shades", pastelShades),
  new ColorMap("blue-orange", blueOrange),
  new ColorMap("black-orange", blackOrange),
  new ColorMap("blue-hue", blueHue),
  new ColorMap("blue-red", blueRed),
  new ColorMap("jet", jet),
  new ColorMap("grayscale", grayScale)
];

export const getColorMap = (id) => {
  return colorMaps.find(colorMap => colorMap.id === id);
};
